import { createContext, useContext } from 'react'

export interface VersionContextType {
  version: string
  setVersion: (version: string) => void
}

export const VersionContext = createContext<VersionContextType | undefined>(undefined)

export function useVersion() {
  const context = useContext(VersionContext)
  if (!context) {
    throw new Error('useVersion must be used within VersionProvider')
  }
  return context
}
